module.exports = __webpack_public_path__ + "img/hudLifeTitle.6f084455.png";